export const SUBSCRIPTION_UNAVAILABLE_MESSAGE =
  "This subscription doesn't exist or you're not eligible for it. Please contact support if you think this is a mistake.";

/**
 * Query param the onboarding flow adds to `/dashboard` when an existing member can't take the
 * invited subscription; the dashboard shows `SUBSCRIPTION_UNAVAILABLE_MESSAGE` once and removes it.
 */
export const SUBSCRIPTION_NOTICE_PARAM = 'subscriptionNotice';
export const SUBSCRIPTION_NOTICE_UNAVAILABLE = 'unavailable';

/**
 * Thrown by a container step when the invited individual subscription can't be offered to the
 * user (not on its allow-list, or the plan doesn't exist). The views render it inline on the
 * form instead of toasting, so the user sees why they can't continue.
 */
export class SubscriptionUnavailableError extends Error {
  constructor() {
    super(SUBSCRIPTION_UNAVAILABLE_MESSAGE);
    this.name = 'SubscriptionUnavailableError';
  }
}
